export default __webpack_public_path__ + "static/clumio-logo-calculator-8b878ee944a936b15181ebcd6afa48cd.svg";